import { toast } from "$global-providers/toast-provider";
import { useUser } from "$global-providers/user-provider";
import { linkToHome } from "$routes/_lib/links";
import TwoButtonModal from "$routes/price-list/_lib/components/modals/two-button-modal";
import { gql } from "@apollo/client";
import { Grid, Typography } from "@material-ui/core";
import { Role } from "elephant-web/gql";
import { FormattedMessage, useIntl } from "react-intl";
import { useNavigate } from "react-router-dom";
import { useCreatePriceListMutation } from "./__generated__/create-price-list-modal.gql";

gql`
  mutation createPriceList($facilityId: ID) {
    priceListV2 {
      createPriceList(input: { facilityId: $facilityId }) {
        priceListId
      }
    }
  }
`;

export const CreatePriceListModal: FC = () => {
  const navigate = useNavigate();
  const { formatMessage } = useIntl();
  const { facilityId, role: roleName } = useUser();
  const isAdmin = roleName === Role.Admin;
  const [createPriceList] = useCreatePriceListMutation({
    variables: {
      facilityId: isAdmin ? null : facilityId,
    },
    onCompleted: (res) => {
      toast.success(
        formatMessage({
          id: "pricelist.createPriceList.success",
          defaultMessage: "Successfully created price list",
        }),
      );
      navigate(`/price-list/${res.priceListV2.createPriceList.priceListId}`);
    },
    onError: () => {
      toast.error(
        formatMessage({
          id: "priceList.createPriceList.error.msg",
          defaultMessage: "Failed to create Price List",
        }),
      );
    },
  });

  const title = isAdmin
    ? formatMessage({
        id: "pricelist.modal.createPriceList.modal.organisation.title",
        defaultMessage: "Create Organisation Price List",
      })
    : formatMessage({
        id: "pricelist.modal.createPriceList.modal.facility.title",
        defaultMessage: "Create Facility Price List",
      });

  return (
    <TwoButtonModal
      open
      icon="warning"
      title={title}
      primaryButtonText={formatMessage({
        id: "priceList.modal.createPriceList.accept",
        defaultMessage: "Create Price List",
      })}
      onPrimaryButtonClicked={createPriceList}
      onSecondaryButtonClicked={() => navigate(linkToHome())}
    >
      <Grid container>
        <Typography variant="body1">
          <FormattedMessage
            id="pricelist.modal.createPriceList.description"
            defaultMessage="You do not have a price list yet. Would you like to create one?"
          />
        </Typography>
      </Grid>
    </TwoButtonModal>
  );
};

export default CreatePriceListModal;
